<div class="modal-header">
    <h5 class="modal-title">{{ description.id ? 'Chỉnh Sửa Mô Tả Vật Lý' : 'Thêm Mô Tả Vật Lý' }}</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="height">Chiều Cao (cm)</label>
        <input type="number" class="form-control" id="height" [(ngModel)]="description.height" name="height">
      </div>
      <div class="form-group">
        <label for="width">Chiều Rộng (cm)</label>
        <input type="number" class="form-control" id="width" [(ngModel)]="description.width" name="width">
      </div>
      <div class="form-group">
        <label for="thickness">Độ Dày (cm)</label>
        <input type="number" class="form-control" id="thickness" [(ngModel)]="description.thickness" name="thickness">
      </div>
      <div class="form-group">
        <label for="weight">Trọng Lượng (gram)</label>
        <input type="number" class="form-control" id="weight" [(ngModel)]="description.weight" name="weight">
      </div>
      <div class="form-group">
        <label for="pageCount">Số Trang</label>
        <input type="number" class="form-control" id="pageCount" [(ngModel)]="description.pageCount" name="pageCount">
      </div>
      <div class="form-group">
        <label for="bindingType">Loại Bìa</label>
        <input type="text" class="form-control" id="bindingType" [(ngModel)]="description.bindingType" name="bindingType">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
    <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Lưu</button>
  </div>

